import { MenuItem, Select, FormHelperText, InputLabel } from '@mui/material';
import FormControl, { FormControlPropsSizeOverrides } from '@mui/material/FormControl';
import { OverridableStringUnion } from '@mui/types';
import React, { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Label } from '../Label/';

export interface WsSelectProps {
  name: string;
  label?: string;
  placeholder?: string;
  selectArray: WsSelectObj[];
  variant?: 'standard' | 'outlined' | 'filled';
  size?: OverridableStringUnion<'small' | 'medium', FormControlPropsSizeOverrides>;
  disabled?: boolean;
  required?: boolean;
  showMandatorySymbol?: boolean;
  defaultValue?: string;
  displayEmpty?: boolean;
  customOption?: ReactNode | undefined;
  onChangeValue?: (val: any) => void;
}
export interface WsSelectObj {
  label: string;
  value: number | string;
}
const WsSelect = ({
  name,
  label,
  selectArray,
  variant = 'outlined',
  size = 'small',
  required = false,
  disabled = false,
  showMandatorySymbol = false,
  placeholder,
  defaultValue,
  displayEmpty = false,
  customOption,
  onChangeValue,
}: WsSelectProps) => {
  const { control } = useFormContext();

  return (
    <FormControl fullWidth variant={variant} size={size} required={required} disabled={disabled}>
      {label && (
        <Label>
          {label}
          {showMandatorySymbol ? ' *' : ''}
        </Label>
      )}
      <Controller
        render={({ field: { onChange, value = defaultValue }, fieldState: { error } }) => (
          <>
            {placeholder && <InputLabel id="select-label-id">{placeholder}</InputLabel>}
            <Select
              labelId="select-label-id"
              id={name}
              onChange={(e) => {
                onChange(e);
                onChangeValue && onChangeValue(e.target.value);
              }}
              value={value}
              required={required}
              disabled={disabled}
              label={placeholder}
              displayEmpty={displayEmpty}
            >
              {selectArray.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
              {customOption}
            </Select>
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
        control={control}
        name={name}
      />
    </FormControl>
  );
};

export default WsSelect;
